import { USER_ROLE } from '../models';

const USER_ROLES = new Set<string>(Object.values(USER_ROLE));

export function isUserRole(role: string): role is USER_ROLE {
  return USER_ROLES.has(role);
}
